// extracted by mini-css-extract-plugin
export var closeButton = "_pl-2";
export var closeButtonIcon = "_pl-3";
export var lightboxContent = "_pl-1";
export var lightboxOverlay = "_pl-0";